import React, { memo } from "react";
import useUploadFile from "./index.hooks";
import { Box, FormHelperText, Typography } from "@material-ui/core";
import { DropzoneArea } from "material-ui-dropzone";
import { AppTextField } from "components";
import { useAtomicStyles } from "../../styles";

export interface UploadFileProps {
  label?: string;
  name?: string;
  onChange: (file: File[]) => void;
  dropzoneText?: string;
  maxFileSize?: number;
  filesLimit?: number;
  error?: boolean;
  helperText?: string;
  inputRef?: any;
}

const UploadFile = ({
  label,
  onChange,
  maxFileSize,
  dropzoneText,
  filesLimit,
  name,
  error,
  helperText,
  inputRef,
  ...props
}: UploadFileProps) => {
  const { styles, classes, isMobile } = useUploadFile();
  return (
    <div className={styles.inn}>
      <Typography variant="h2" className={styles.label}>
        {label}
      </Typography>
      <DropzoneArea
        previewGridProps={{
          item: {
            md: 8,
            xs: 8,
          },
        }}
        filesLimit={filesLimit}
        maxFileSize={maxFileSize}
        onChange={onChange}
        dropzoneText={!isMobile ? dropzoneText : ""}
        classes={classes.rootMobile}
        {...props}
      />
      {error && (
        <FormHelperText error className={styles.inputHelper}>
          {helperText}
        </FormHelperText>
      )}
      {inputRef !== undefined && name !== undefined && (
        <Box display="none">
          <AppTextField name={name} inputRef={inputRef} />
        </Box>
      )}
    </div>
  );
};

export default memo(UploadFile);
